const API_ENDPOINT = 'https://xperiate-ai-chatbot-agent.vercel.app/chat';
  const STORAGE_KEY = 'xperiate_chat_history';
  const SESSION_KEY = 'xperiate_session_id';

  function getSessionId() {
    let sid = localStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  }

  const SESSION_ID = getSessionId();
  let conversationHistory = [];
  let isOpen = false;
  let isTyping = false;

  function loadHistory() {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) {
        conversationHistory = JSON.parse(saved);
        const container = document.getElementById('chatMessages');
        container.innerHTML = '';

        conversationHistory.forEach(item => {
          if (item.assistant) {
            addMessage(item.assistant, false, false);
          }
          if (item.user) {
            addMessage(item.user, true, false);
          }
        });
      }
    } catch (e) {
      console.error('Failed to load chat history:', e);
    }
  }

  function saveHistory() {
    try {
      const recentHistory = conversationHistory.slice(-50);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(recentHistory));
    } catch (e) {
      console.error('Failed to save chat history:', e);
    }
  }

  function endChat() {
    if (confirm('End this chat session? You can start a new conversation anytime.')) {
      conversationHistory = [];
      localStorage.removeItem(STORAGE_KEY);

      const newSessionId = 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
      localStorage.setItem(SESSION_KEY, newSessionId);

      const container = document.getElementById('chatMessages');
      container.innerHTML = '';
      addMessage(getGreeting(), false, false);

      window.location.reload();
    }
  }

  function toggleChat() {
    isOpen = !isOpen;
    document.getElementById('chatContainer').classList.toggle('active');
    if (isOpen) {
      document.getElementById('messageInput').focus();
      setTimeout(() => {
        const container = document.getElementById('chatMessages');
        container.scrollTop = container.scrollHeight;
      }, 100);
    }
  }

  function handleKeyPress(event) {
    if (event.key === 'Enter' && !isTyping) sendMessage();
  }

  function addMessage(content, isUser = false, save = true) {
    const container = document.getElementById('chatMessages');
    const msg = document.createElement('div');
    msg.className = `message ${isUser ? 'user' : 'bot'}`;

    let formattedContent = content;
    if (!isUser) {
      formattedContent = content.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" style="color: #667eea; text-decoration: underline;">$1</a>');
    }

    msg.innerHTML = `
      <div class="avatar ${isUser ? 'user-avatar' : 'bot-avatar'}">
        ${!isUser ? `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
        </svg>` : ''}
      </div>
      <div class="message-content">${formattedContent}</div>`;
    container.appendChild(msg);
    container.scrollTop = container.scrollHeight;

    if (save) saveHistory();
  }

  function showTypingIndicator() {
    const container = document.getElementById('chatMessages');
    const indicator = document.createElement('div');
    indicator.className = 'typing-indicator';
    indicator.id = 'typingIndicator';
    indicator.innerHTML = `
      <div class="typing-dot"></div>
      <div class="typing-dot"></div>
      <div class="typing-dot"></div>
    `;
    container.appendChild(indicator);
    container.scrollTop = container.scrollHeight;
  }

  function hideTypingIndicator() {
    const indicator = document.getElementById('typingIndicator');
    if (indicator) indicator.remove();
  }

  function getGreeting() {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning! I'm the Xperiate Online Assistant. How can I help you find your perfect trendy apparel today?";
    if (hour < 18) return "Good afternoon! Looking for some fresh, custom apparel? I'm here to help!";
    return "Good evening! Ready to upgrade your style? Let me help you find something amazing!";
  }

  function sendMessage() {
    const input = document.getElementById('messageInput');
    const message = input.value.trim();
    if (!message || isTyping) return;

    input.value = '';
    isTyping = true;

    addMessage(message, true);
    showTypingIndicator();

    const requestHistory = [];
    conversationHistory.forEach(item => {
      if (item.user) requestHistory.push({ user: item.user });
      if (item.assistant) requestHistory.push({ assistant: item.assistant });
    });

    fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-ID': SESSION_ID
      },
      body: JSON.stringify({
        message: message,
        session_id: SESSION_ID,
        conversation_history: requestHistory
      })
    })
    .then(res => {
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return res.json();
    })
    .then(data => {
      hideTypingIndicator();
      isTyping = false;

      const response = data.response || "I'm sorry, I didn't understand that. Could you please try again?";
      addMessage(response, false);

      if (conversationHistory.length === 0 && !conversationHistory.find(h => h.assistant)) {
        conversationHistory.push({ assistant: getGreeting() });
      }
      conversationHistory.push({ user: message, assistant: response });
      saveHistory();
    })
    .catch(err => {
      console.error('Chat error:', err);
      hideTypingIndicator();
      isTyping = false;
      addMessage('Sorry, something went wrong. Please try again.', false);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    loadHistory();

    if (conversationHistory.length === 0) {
      addMessage(getGreeting(), false, false);
    }

    // Update cart count on page load
    if (window.XperiateTheme && window.XperiateTheme.updateCartCount) {
      window.XperiateTheme.updateCartCount();
    }

    setTimeout(() => {
      if (!isOpen && !localStorage.getItem('chatShown')) {
        toggleChat();
        localStorage.setItem('chatShown', 'true');
      }
    }, 5000);
  });